module.exports = __webpack_public_path__ + "static/media/google-play.8412cc2c.png";